import React, { useMemo } from 'react';
import ProductFiltering from '../ProductFiltering/ProductFiltering';
import SideMenu from '../SideMenu/SideMenu';
import { translate } from '../../Services/translation';
import ProductSortingRadios from './ProductSortingRadios';
import { clearAllFilters } from '../../Actions/ProductFiltering.action';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import CategoriesMenu from './CategoriesMenu';

const FilterMenu = ({
  currentMenu,
  setCurrentMenu,
}: {
  currentMenu: string | undefined;
  setCurrentMenu: any;
}) => {
  const dispatch = useDispatch();
  const { totalProductsCount } = useTypedSelector(
    (state) => state.productListing
  );
  const filters = useTypedSelector(
    (state) => state.productFiltering.filters
  );
  const hasAnyOptionSelected = useMemo(() => {
    if (filters && filters.length > 0) {
      return filters.findIndex((f) => f.selectedOptions.length > 0) != -1;
    }
    return false;
  }, [filters]);

  const Header = () => (
    <>
      {currentMenu == 'categories' ? (
        <h4>{translate('filter.categories')}</h4>
      ) : null}
      {currentMenu == 'filters' ? (
        <h4>{translate('filter.filter')}</h4>
      ) : null}
      {currentMenu == 'sorting' ? (
        <h4>{translate('filter.sort')}</h4>
      ) : null}
    </>
  );

  const Content = () => (
    <>
      {currentMenu == 'categories' ? <CategoriesMenu /> : null}
      {currentMenu == 'filters' ? (
        <div className="[&_.ReactCollapse--collapse[aria-hidden='false']_.ReactCollapse--content]:px-4 [&_.ReactCollapse--collapse[aria-hidden='false']_.ReactCollapse--content_button]:mt-4 [&_.ReactCollapse--collapse[aria-hidden='false']_.ReactCollapse--content_label]:px-0 [&_.ReactCollapse--collapse[aria-hidden='false']_.ReactCollapse--content_label]:py-1 [&_.collapsible(:last-child)]:border-0 [&_.collapsible]:border-b-0 [&_.collapsible]:border-t-0 [&_.collapsible]:border-gray-300 [&_label]:px-4">
          <ProductFiltering />
        </div>
      ) : null}
      {currentMenu == 'sorting' ? <ProductSortingRadios /> : null}
    </>
  );

  const Footer = () => (
    <>
      {currentMenu == 'filters' ? (
        <div className="flex flex-1 gap-2">
          <button
            className="btn btn--outline btn--large w-full font-bold uppercase"
            disabled={!hasAnyOptionSelected}
            onClick={() => dispatch(clearAllFilters())}
          >
            {translate('filter.clear')}
          </button>
          <button
            className="btn btn--secondary btn--large w-full"
            onClick={() => setCurrentMenu(undefined)}
          >
            {translate('filter.view')} ({totalProductsCount})
          </button>
        </div>
      ) : null}
    </>
  );

  return (
    <>
      <SideMenu
        from="right"
        id="filter-menu"
        open={!!currentMenu}
        onClosed={() => setCurrentMenu(undefined)}
        components={{ Header, Content, Footer }}
        className="z-[60] overflow-y-auto border-gray-300 bg-white scrollbar-none sm:max-w-[360px] sm:border-l"
      ></SideMenu>
    </>
  );
};

export default FilterMenu;
